function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./ViewSwitcherHits"));
__export(require("./ViewSwitcherToggle"));
__export(require("./ViewSwitcherConfig"));
//# sourceMappingURL=index.js.map